import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { Button } from "../Button";

const NAVIGATION_CONTEXT_TOOLTIP =
  "A search must be performed to provide previous and next context.";

const SearchResultNavigation = ({
  hasNavigationContext,
  hasNext,
  hasPrevious,
  navigationLoading,
  navigateToNext,
  navigateToPrevious,
  showNavigationControls,
}) => {
  if (!showNavigationControls) return null;

  return (
    <div
      className="flex flex-wrap items-center gap-2"
      title={!hasNavigationContext ? NAVIGATION_CONTEXT_TOOLTIP : ""}
    >
      <Button
        action="default"
        ariaLabel="Previous"
        className="!w-auto"
        customPadding="p-2 lg:px-4 lg:py-2"
        disabled={navigationLoading || !hasNavigationContext || !hasPrevious}
        label={
          <>
            <ChevronLeftIcon className="h-4 w-4 lg:hidden" aria-hidden="true" />
            <span className="hidden lg:inline">Previous</span>
          </>
        }
        onClick={navigateToPrevious}
      />
      <Button
        action="default"
        ariaLabel="Next"
        className="!w-auto"
        customPadding="p-2 lg:px-4 lg:py-2"
        disabled={navigationLoading || !hasNavigationContext || !hasNext}
        label={
          <>
            <ChevronRightIcon
              className="h-4 w-4 lg:hidden"
              aria-hidden="true"
            />
            <span className="hidden lg:inline">Next</span>
          </>
        }
        onClick={navigateToNext}
      />
    </div>
  );
};

export { NAVIGATION_CONTEXT_TOOLTIP, SearchResultNavigation };
